export default "__VITE_ASSET__69b977e1__"